import React from 'react';
import { range } from 'lodash';
import SettingsForm from '../ui-kit/SettingsForm';

const DutyPlannerWidgetSettings = ({ updateWidgetSettingsField, widgetSettings }) => (
  <SettingsForm updateWidgetSettingsField={updateWidgetSettingsField} widgetSettings={widgetSettings}>
    <SettingsForm.Section>
      <SettingsForm.Section.Header>{I18n.t('general')}</SettingsForm.Section.Header>
      <SettingsForm.Section.Content>
        <SettingsForm.ToggleField
          fieldName="fixedPeriod"
          label={I18n.t('dashboards.widget_archetypes.duty_planner.settings.fixed_period')}
        />
        {widgetSettings.fixedPeriod && (
          <SettingsForm.Select
            fieldName="startHour"
            options={range(24)}
            label={I18n.t('dashboards.widget_archetypes.duty_planner.settings.start_hour')}
          />
        )}
        {widgetSettings.fixedPeriod || (
          <SettingsForm.Select
            fieldName="lookBackHours"
            options={range(1, 24)}
            label={I18n.t('dashboards.widget_archetypes.duty_planner.settings.look_back_hours')}
          />
        )}
        <SettingsForm.Select
          fieldName="lookAheadHours"
          options={range(1, 49)}
          label={I18n.t('dashboards.widget_archetypes.duty_planner.settings.look_ahead_hours')}
        />
      </SettingsForm.Section.Content>
    </SettingsForm.Section>
  </SettingsForm>
);

export default DutyPlannerWidgetSettings;
